(function (window, document, $) {
    'use strict';

    $(function () {
        $('#form-site-search').on('click', '.btn-reset', function (evt) {
            $(evt.delegateTarget).find('input').val('');
        });
    });
}(window, document, jQuery));